import React from 'react';
import styled from 'App/styled';

const CopyrightsWrap = styled.div`
  background-color: ${(props) => props.theme.brandPrimary};
  color: #ffffff;
  padding-bottom: 10px;
  text-align: center;
`;

// Replace with new token
const CopyrightsText = styled.p`
  ${({ theme }) => theme.typography.bodySmall};
  line-height: 20px;
`;

const Copyrights = () => (
  <>
    <CopyrightsWrap>
      <CopyrightsText>
        <span>&copy;</span> {new Date().getFullYear()} NYKAA E-RETAIL LIMITED
        All Rights Reserved.
      </CopyrightsText>
    </CopyrightsWrap>
  </>
);

export default Copyrights;
